import React, {useContext, useEffect, useRef} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  const mapRef = useRef(null);

  useEffect(() => {
    // Load the map widget script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'mapmyvisitors';
    script.src = 'https://mapmyvisitors.com/map.js?cl=55198b&w=a&t=m&d=wW6wUTgXQN17IBIgzX2a0AgvEa-Tp7D6D_05_ZZY38E&co=ffffff&ct=808080&cmo=3acc3a&cmn=ff5353';
    script.async = true;

    if (mapRef.current) {
      mapRef.current.appendChild(script);
    }

    // Cleanup function to remove script when component unmounts
    return () => {
      if (mapRef.current && mapRef.current.contains(script)) {
        mapRef.current.removeChild(script);
      }
      // Also remove the script from document if it exists
      const existingScript = document.getElementById('mapmyvisitors');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-header">
            <h1 className="heading contact-title">{contactInfo.title}</h1>
            <p
              className={
                isDark
                  ? "dark-mode contact-subtitle"
                  : "subTitle contact-subtitle"
              }
            >
              {contactInfo.subtitle}
            </p>
            <div
              className={
                isDark ? "dark-mode contact-text-div" : "contact-text-div"
              }
            >
              {contactInfo.number && (
                <>
                  <a
                    className="contact-detail"
                    href={"tel:" + contactInfo.number}
                  >
                    {contactInfo.number}
                  </a>
                  <br />
                  <br />
                </>
              )}
              <a
                className="contact-detail-email"
                href={"mailto:" + contactInfo.email_address}
              >
                {contactInfo.email_address}
              </a>
              <br />
              <br />
              <SocialMedia />
            </div>
          </div>
          <div className="contact-image-div" ref={mapRef}>
            {/* Map widget will be loaded here */}
          </div>
        </div>
      </div>
    </Fade>
  );
}
